<template>
    <v-card v-if="options">
        <v-card-title primary-title>
            Put:Call Ratio
        </v-card-title>
        <v-card-text>
            <h2 :class="{'display-2' : true, 'green--text': ratio < 1, 'red--text': ratio >= 1}">
                {{ratio.toFixed(2)}}
            </h2>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
  props: {
    options: {
      type: Object,
    },
  },
  data() {
    return {

    };
  },

  computed: {
    ratio() {
      let totalCallOpenInterest = 0;
      let totalPutOpenInterest = 0;
      Object.keys(this.options).forEach((expiration) => {
        const options = this.options[expiration];
        options.forEach((opt) => {
          if (opt.option_type === 'put') {
            totalPutOpenInterest += opt.open_interest;
          } else if (opt.option_type === 'call') {
            totalCallOpenInterest += opt.open_interest;
          }
        });
      });

      if (totalCallOpenInterest > 0) {
        return (totalPutOpenInterest / totalCallOpenInterest);
      }

      return NaN;
    },
  },


};
</script>
